import i18n from 'i18next'
import k from './../../i18n/keys'
import { Box, FormControl } from '@mui/material'
import React, { useState } from 'react'
import { styled } from '@mui/material/styles'

import { Button, Input, Typography } from '@evocolabs/orkaui'
import theme from '@evocolabs/orkaui/lib/theme.cjs'
import { useBackend } from '@/src/providers/BackendProvider'
import validateEmail from '@/src/utils/validateEmail'
import { useRouter } from 'next/router'

const SignInResetPwdEmail = ({ setResetPwdEmail, setCurrentView }) => {
  const { sendResetPasswordEmail, asyncUserEmailTakenStatus } = useBackend()
  const [email, setEmail] = useState('')
  const [errors, setErrors] = useState('')
  const router = useRouter()

  const checkInfo = () => {
    return errors === '' && email !== ''
  }

  const handleBackToSignIn = () => {
    router.push('/SignIn')
  }

  const handleChange = (event) => {
    setEmail(event.target.value)
    setErrors('')
  }

  const handleClick = async () => {
    if (checkInfo()) {
      if (!validateEmail(email)) {
        setErrors('Invalid email address.')
        throw new Error('Invalid email address.')
      }
      if (!(await asyncUserEmailTakenStatus(email))) {
        setErrors(
          'The email address you’ve entered is not associated with a registered account.'
        )
      } else {
        await sendResetPasswordEmail(email)
        setResetPwdEmail(email)
        setCurrentView('EmailSent')
      }
    } else {
      if (email === '') {
        setErrors('Empty email address: Required field.')
      }
      throw new Error('invalid input')
    }
  }

  function handleKeyDown(e) {
    if (e.keyCode === 13) {
      document.getElementById('button').click()
      e.preventDefault()
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <Typography variant="h4">Reset your password</Typography>
        <Typography variant="body2">
          {i18n.t(k.WE_LL_SEND_YOU_AN_EMAIL_WITH_I)}
        </Typography>
      </div>

      <FormControl>
        <Input
          placeholder="Email"
          inputProps={{ maxLength: 50 }}
          fullWidth
          type="email"
          value={email}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          required
          errorMsg={errors}
        />
      </FormControl>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          alignItems: 'center'
        }}
      >
        <Button
          color="primary"
          id="button"
          loadable
          size="large"
          width="184px"
          handleClick={handleClick}
        >
          {i18n.t(k.SEND)}
        </Button>
        <Typography variant="body3">
          {i18n.t(k.BACK_TO)}&nbsp;
          <Typography
            variant="Link"
            onClick={handleBackToSignIn}
            color={theme.palette.multicolor[300]}
          >
            {i18n.t(k.SIGN_IN1)}
          </Typography>
        </Typography>
      </div>
    </div>
  )
}

export default SignInResetPwdEmail
